import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { Box, Button } from '@material-ui/core'

import { Autocomplete } from 'components'

import useStyles from './styles'

const SelectExistingField = ({
  companyFragilities,
  isLoading,
  linkedFragilities,
  stagedFragilities,
  onStage,
  saving,
}) => {
  const [selectedFragility, setSelectedFragility] = useState(null)

  const classes = useStyles()

  const options = useMemo(() => {
    const excludedFragilityIds = [
      ...linkedFragilities.map((item) => item.companyFragility?.id),
      ...stagedFragilities
        .filter((item) => !item.isNew)
        .map((item) => item.companyFragilityId),
    ]

    return companyFragilities.filter(
      (option) => !excludedFragilityIds.includes(option.id),
    )
  }, [companyFragilities, linkedFragilities, stagedFragilities])

  const handleStage = () => {
    if (!selectedFragility) return

    onStage({
      companyFragilityId: selectedFragility.id,
      name: selectedFragility.name,
      isNew: false,
    })
    setSelectedFragility(null)
  }

  return (
    <Box className={classes.row}>
      <Autocomplete
        className={classes.grow}
        options={options}
        loading={isLoading}
        value={selectedFragility}
        onChange={(_, value) => setSelectedFragility(value)}
        getOptionLabel={(option) => option?.name ?? ''}
        getOptionSelected={(option, value) => option.id === value?.id}
        textFieldProps={{
          label: 'Selecionar ameaças',
          variant: 'outlined',
        }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleStage}
        disabled={!selectedFragility || saving}
      >
        Adicionar
      </Button>
    </Box>
  )
}

SelectExistingField.propTypes = {
  companyFragilities: PropTypes.array,
  isLoading: PropTypes.bool,
  linkedFragilities: PropTypes.array,
  stagedFragilities: PropTypes.array,
  onStage: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

export default SelectExistingField
